import type { FileItem } from "types/interfaces/filesStorage";
import { ACTIONS } from "./access";

/** What the user may change on Data Storage, as the server decided it. */
export interface DataStorageRights {
  organize: boolean;
  deleteData: boolean;
  clientFolders: boolean;
  renameFiles: boolean;
}

export function dataStorageRights(
  sees: (key: string) => boolean,
): DataStorageRights {
  return {
    organize: sees(ACTIONS.DATA_STORAGE_ORGANIZE),
    deleteData: sees(ACTIONS.DATA_STORAGE_DELETE),
    clientFolders: sees(ACTIONS.DATA_STORAGE_CLIENT_FOLDERS),
    renameFiles: sees(ACTIONS.DATA_STORAGE_RENAME_FILES),
  };
}

export interface RowControls {
  rename: boolean;
  move: boolean;
  remove: boolean;
}

/**
 * The row menu of Data Storage. At the root a row is a client folder, and
 * renaming or removing it takes Contribute. Inside a folder View renames data
 * folders and moves files, and deleting anything takes Contribute. A control
 * the user cannot use is not shown at all.
 */
export function rowControls(
  rights: DataStorageRights,
  row: Pick<FileItem, "ftype" | "is_integration" | "user_folder_id">,
  insideFolder: boolean,
): RowControls {
  if (!insideFolder) {
    const clientFolder =
      row.ftype === "folder" && typeof row.user_folder_id === "number";
    return {
      rename: clientFolder && rights.clientFolders && !row.is_integration,
      move: false,
      remove: clientFolder && rights.clientFolders,
    };
  }
  return {
    rename: row.ftype === "folder" && rights.organize,
    move: row.ftype === "file" && rights.organize,
    remove: rights.deleteData,
  };
}

/**
 * Rename file: a file row, the user holds the action, and the listing says the
 * files of this folder are renamed here at all - the server keeps integration,
 * SFTP and other buckets' folders out, since others find those files by name.
 */
export function renamesFile(
  rights: DataStorageRights,
  row: Pick<FileItem, "ftype">,
  filesRenamable: boolean,
): boolean {
  return row.ftype === "file" && rights.renameFiles && filesRenamable;
}
